import { LANGUAGES, useI18n } from "../../i18n";

/**
 * AZ / EN / RU keçidi.
 *  - compact: mobil başlıqda (daha dar)
 *  - full: drawer-in altında tam enli
 */
const LanguageSwitcher = ({ compact = false, full = false }) => {
  const { lang, setLang } = useI18n();

  return (
    <div
      className={`flex items-center bg-white/10 rounded-xl p-0.5 border border-white/10 ${
        full ? "w-full" : ""
      }`}
      role="group"
      aria-label="Language"
    >
      {LANGUAGES.map((item) => (
        <button
          key={item.code}
          onClick={() => setLang(item.code)}
          title={item.name}
          aria-label={item.name}
          aria-pressed={lang === item.code}
          className={`${full ? "flex-1" : ""} ${
            compact ? "px-2 py-1.5" : "px-2.5 py-1.5"
          } text-xs font-bold rounded-lg transition active:scale-95 ${
            lang === item.code
              ? "bg-white text-indigo-700 shadow"
              : "text-white/70 hover:text-white hover:bg-white/10"
          }`}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
